import { Col } from 'components/Col';
import { CustomTextField } from 'components/CustomTextField';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { ChangeEvent, useContext, useMemo } from 'react';
import { getFormattedDate } from 'utils/DataFormatUtils';
import languageValues from 'utils/LanguageUtils';

const language = languageValues.inputs;
export default function Periodos() {
  const { state, dispatch, validator } = useContext(ProjetosContext);

  const validation = useMemo(
    () => {
      return {
        periodoInicial: validator?.getCampoIsValid({
          key: 'periodoInicial',
          etapa: EtapaProjeto.indiceFinal,
          helperText: language.periodoInicial.required,
        }),
        periodoFinal: validator?.getCampoIsValid({
          key: 'periodoFinal',
          etapa: EtapaProjeto.indiceFinal,
          helperText: language.periodoFinal.required,
        }),
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );
  return (
    <Row>
      <Col cols={[12, 6, 6, 6, 6]}>
        <CustomTextField
          disabled
          label={language.periodoInicial.label}
          placeholder={language.periodoInicial.placeholder}
          name='periodoInicial'
          value={state.projeto.periodoInicial ?? ''}
          onChange={(evt: ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: 'setProjeto',
              payload: {
                periodoInicial: getFormattedDate(evt.target.value),
              },
            });
          }}
          maxSize={10}
          error={state.sent && validation?.periodoInicial?.error}
          helperText={
            state.sent && validation?.periodoInicial?.error
              ? validation?.periodoInicial?.helperText
              : undefined
          }
        />
      </Col>
      <Col cols={[12, 6, 6, 6, 6]}>
        <CustomTextField
          label={language.periodoFinal.label}
          placeholder={language.periodoFinal.placeholder}
          name='periodoFinal'
          value={state.projeto.periodoFinal ?? ''}
          onChange={(evt: ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: 'setProjeto',
              payload: {
                periodoFinal: getFormattedDate(evt.target.value),
              },
            });
          }}
          maxSize={10}
          error={state.sent && validation?.periodoFinal?.error}
          helperText={
            state.sent && validation?.periodoFinal?.error
              ? validation?.periodoFinal?.helperText
              : undefined
          }
          disabled={state.disabledFields}
        />
      </Col>
    </Row>
  );
}
